import { PlayCircleOutlined } from '@ant-design/icons';
import { IconCircle, IconEdit } from '@nxsys/components/AppIconSvg';
import { formatMoney } from '@nxsys/utils/number-helper';
import {
  ACTIONS_STATUTORY_TYPE,
  STATUTORY_PAYMENT_STATUS,
  STATUTORY_PAYMENT_TYPE,
} from '@nxsys/constants/statutory';
import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import AppTagStatus from '@nxsys/components/AppTagStatus';
import { formatStatus } from '@nxsys/utils';

export const getColumns = ({
  type,
  statutoryDetail,
  isEditing = false,
  handleOpenActionModal,
  messages,
}: {
  type:
    | (typeof STATUTORY_PAYMENT_TYPE)[keyof typeof STATUTORY_PAYMENT_TYPE]
    | undefined;
  statutoryDetail: any;
  isEditing: boolean;
  handleOpenActionModal: (type: string, record: any) => void;
  messages: any;
}): ColumnsType<any> => {
  return [
    ...(isEditing
      ? [
          {
            key: 'actions',
            title: messages['statutory.column.actions'],
            fixed: 'left',
            align: 'left',
            render: (record: any) => (
              <ul className="table-actions flex items-center justify-center">
                {(type === STATUTORY_PAYMENT_TYPE.SMP ||
                  type === STATUTORY_PAYMENT_TYPE.SAP) &&
                  statutoryDetail?.status === STATUTORY_PAYMENT_STATUS.NEW && (
                    <li>
                      <div
                        onClick={() =>
                          handleOpenActionModal(
                            ACTIONS_STATUTORY_TYPE.EDIT,
                            record,
                          )
                        }
                      >
                        <Tooltip title="Edit">
                          <span><IconEdit /></span>
                        </Tooltip>
                      </div>
                    </li>
                  )}
                <li>
                  {record.stopReason ? (
                    <div
                      onClick={() =>
                        handleOpenActionModal(
                          ACTIONS_STATUTORY_TYPE.RESUME,
                          record,
                        )
                      }
                    >
                      <Tooltip title="Resume">
                        <PlayCircleOutlined
                          style={{
                            color: defaultTheme.theme.palette.primary.main,
                          }}
                        />
                      </Tooltip>
                    </div>
                  ) : (
                    <div
                      onClick={() =>
                        handleOpenActionModal(
                          ACTIONS_STATUTORY_TYPE.STOP,
                          record,
                        )
                      }
                    >
                      <Tooltip title="Stop">
                        <span><IconCircle /></span>
                      </Tooltip>
                    </div>
                  )}
                </li>
              </ul>
            ),
            width: 150,
          } as any,
        ]
      : []),
    {
      key: 'amount',
      title: messages['statutory.column.amount'],
      align: 'right',
      render: (value) =>
        formatMoney(
          value?.sspAmount ??
            value?.smpAmount ??
            value?.sapAmount ??
            value?.sppaAmount ??
            value?.sppAmount,
        ),
    },
    {
      key: 'status',
      title: messages['statutory.column.status'],
      dataIndex: 'status',
      align: 'center',
      render: (value) => (
        <AppTagStatus className={`tag-popup ${formatStatus(value)}`}>
          {formatStatus(value)}
        </AppTagStatus>
      ),
      width: 150,
    },
    {
      key: 'taxWeek',
      title: messages['statutory.column.taxPeriod'],
      dataIndex: 'taxWeek',
      align: 'right',
    },
    {
      key: 'taxYear',
      title: messages['statutory.column.taxYear'],
      dataIndex: 'taxYear',
      align: 'right',
    },
    {
      key: 'stopReason',
      title: messages['statutory.column.stopReason'],
      dataIndex: 'stopReason',
    },
    ...(type === STATUTORY_PAYMENT_TYPE.SAP ||
    type === STATUTORY_PAYMENT_TYPE.SMP
      ? [
          {
            key: 'keepingInTouchDays',
            title: messages['statutory.column.kitDaysUsed'],
            dataIndex: 'keepingInTouchDays',
            align: 'right',
          },
          {
            key: 'remark',
            title: messages['statutory.column.remark'],
            dataIndex: 'remark',
          },
        ]
      : []),
  ];
};
